import z from 'zod';
const ldndHeaderSchema = z.looseObject({
    msn: z.string().optional(),
    registration: z.string().optional(),
    date: z.string().optional(),
    engineTSN: z.number().optional(),
    engineCSN: z.number().optional(),
    engineSN: z.string().optional(),
    engineModel: z.string().optional(),
    aircraftModel: z.string().optional(),
});
export const ldndStatusEventsReadyWebhookSchema = z.looseObject({
    type: z.literal('ldnd-status-events-ready'),
    projectId: z.string(),
    // `z.iso.datetime()`, not a bare string: the consumer contract is an ORDERABLE instant,
    // so the schema enforces what the field documents. Follows `pma-der-events-ready` /
    // `document-header-ready` rather than the looser `project-progress` / `project-data-ready`
    // spelling.
    //
    // Required. Brain always emits this stamp. An envelope without it does not parse (DR-3341).
    generatedAt: z.iso.datetime(),
    generation: z.number().int().positive().max(2_147_483_647).optional(),
    documentId: z.string(),
    pageIds: z.array(z.string()),
    header: ldndHeaderSchema.optional(),
    ldndStatusEvents: z.array(z.looseObject({
        rowIndex: z.number(),
        ldndReference: z.string(),
        taskDescription: z.string(),
        complianceDate: z.string().optional(),
        complianceTsn: z.number().optional(),
        complianceCsn: z.number().optional(),
        complianceShopVisit: z.string().optional(),
        nextDueHours: z.number().optional(),
        nextDueCycles: z.number().optional(),
        nextDueDate: z.string().optional(),
        nextDueShopVisit: z.string().optional(),
        nextDueAtShopVisit: z.boolean().optional(),
        repeatIntervalHours: z.number().optional(),
        repeatIntervalCycles: z.number().optional(),
        repeatIntervalDays: z.number().optional(),
        repeatIntervalShopVisits: z.number().optional(),
        remarks: z.string().optional(),
        unknownFlag: z.boolean().optional(),
        notApplicable: z.boolean().optional(),
        ldndPageIds: z.array(z.string()),
        // DR-5191: the identity of the emitted task's normalised description — 16 lower-case hex
        // characters (a sha256 prefix), or '' for a blank or noise description; equal to the graph
        // node suffix when the graph splits that task. A plain string, no format check: a failed
        // check would reject the whole family delivery.
        taskIdentityDigest: z.string().optional(),
    })),
});
//# sourceMappingURL=ldnd-status-events-ready.webhook.js.map